import { action } from 'typesafe-actions'

import {
  AuthActionTypes,
  AuthByQRCodeRequest,
  AuthByUsernameRequest,
  AuthForgotPassword,
  AuthResponse
} from './types'

export const authByQRCode = ({ user_key }: AuthByQRCodeRequest) =>
  action(AuthActionTypes.AUTH_BY_QR_CODE, { user_key })

export const authByUsername = ({ password, username }: AuthByUsernameRequest) =>
  action(AuthActionTypes.AUTH_BY_USERNAME, { password, username })

export const authForgotPassword = ({ username }: AuthForgotPassword) =>
  action(AuthActionTypes.AUTH_FORGOT_PASSWORD, { username })

export const authForgotPasswordFailure = (message: string) =>
  action(AuthActionTypes.AUTH_FORGOT_PASSWORD_FAILURE, { message })

export const authForgotPasswordSuccess = (message: string) =>
  action(AuthActionTypes.AUTH_FORGOT_PASSWORD_SUCCESS, { message })

export const authFailure = () => action(AuthActionTypes.AUTH_FAILURE)

export const authLogout = () => action(AuthActionTypes.AUTH_LOGOUT)

export const authSuccess = (response: AuthResponse) =>
  action(AuthActionTypes.AUTH_SUCCESS, { response })
